// Schnur Scale Table (BSA to Grams)
const schnurData = [
    { bsa: 1.35, g: 199 }, { bsa: 1.40, g: 218 }, { bsa: 1.45, g: 238 },
    { bsa: 1.50, g: 260 }, { bsa: 1.55, g: 284 }, { bsa: 1.60, g: 310 },
    { bsa: 1.65, g: 338 }, { bsa: 1.70, g: 370 }, { bsa: 1.75, g: 404 },
    { bsa: 1.80, g: 441 }, { bsa: 1.85, g: 482 }, { bsa: 1.90, g: 527 },
    { bsa: 1.95, g: 575 }, { bsa: 2.00, g: 628 }, { bsa: 2.10, g: 750 },
    { bsa: 2.20, g: 895 }, { bsa: 2.30, g: 1068 }, { bsa: 2.40, g: 1275 },
    { bsa: 2.50, g: 1522 }
];

document.addEventListener('DOMContentLoaded', function() {
    // Only run if calculator elements exist on the page
    const calculatorContainer = document.getElementById('heightSlider');
    if (!calculatorContainer) return;

    const elements = {
        feet: document.getElementById('feet'),
        inches: document.getElementById('inches'),
        weight: document.getElementById('weight'),
        hSlider: document.getElementById('heightSlider'),
        wSlider: document.getElementById('weightSlider'),
        bsaDisplay: document.getElementById('bsaResult'),
        schnurDisplay: document.getElementById('schnurResult')
    };

function updateResults() {
    const hFeet = parseInt(elements.feet.value, 10) || 0;
    const hInches = parseInt(elements.inches.value, 10) || 0;
    const h = (hFeet * 12) + hInches;
    const w = parseFloat(elements.weight.value) || 0;

    // If height or weight are zero or invalid, show zeros
    if (h <= 0 || w <= 0) {
        elements.bsaDisplay.innerText = '0.00';
        elements.schnurDisplay.innerText = '0 g';
        return;
    }

    // BSA (Mosteller Formula): sqrt((cm * kg) / 3600)
    const hCm = h * 2.54;
    const wKg = w * 0.453592;
    const bsa = Math.sqrt((hCm * wKg) / 3600);

    elements.bsaDisplay.innerText = bsa.toFixed(2);

    // Find value in Schnur Table
    const match = schnurData.find(d => bsa <= d.bsa) || schnurData[schnurData.length - 1];
    elements.schnurDisplay.innerText = `${match.g} g`;
}

// Sync sliders and inputs
elements.hSlider.oninput = (e) => {
    elements.feet.value = Math.floor(e.target.value / 12);
    elements.inches.value = e.target.value % 12;
    updateResults();
};

elements.wSlider.oninput = (e) => {
    elements.weight.value = e.target.value;
    updateResults();
};

[elements.feet, elements.inches, elements.weight].forEach(el => {
    el.oninput = () => {
        elements.hSlider.value = (parseInt(elements.feet.value) * 12) + parseInt(elements.inches.value);
        elements.wSlider.value = elements.weight.value;
        updateResults();
    };
});

// Default zeros
elements.feet.value = '0';
elements.inches.value = '0';
elements.weight.value = '0';
elements.hSlider.value = '0';
elements.wSlider.value = '0';

updateResults();

});